import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Layout from '../templates/Layout';
import H1 from '../atoms/title/H1';
import Stats from '../organisms/Stats';
import Panel from '../atoms/Panel';
import DashboardChart from '../molecules/DashboardChart';
import ChartStats from '../molecules/ChartStats';
import Flex from '../atoms/Flex';
import ChartLegend from '../molecules/ChartLegend';
import { Helmet } from 'react-helmet';
import Notice from '../molecules/Notice';
export const RANGE = {
    YEAR: 365,
    MONTH: 30,
};
const Dashboard = ({ statisticsMonth, statisticsYear, notice, }) => {
    const [statistics, setStatistics] = useState(statisticsMonth);
    const [range, setRange] = useState(RANGE.MONTH);
    const openDossiers = statistics?.open_dossiers?.amount || 0;
    const openValue = statistics?.outstanding_balance?.amount || 0;
    useEffect(() => {
        if (range === RANGE.YEAR) {
            setStatistics(statisticsYear);
        }
        else if (range === RANGE.MONTH) {
            setStatistics(statisticsMonth);
        }
        else {
            throw new Error(`Statistics range ${range} is not allowed.`);
        }
    }, [range]);
    return (_jsxs(Layout, { children: [_jsx(Helmet, { children: _jsx("title", { children: "Dashboard" }) }), notice && _jsx(Notice, { ...notice }), _jsx(H1, { "data-testid": "title", children: "Dashboard" }), _jsx(Stats, { statistics: statistics }), _jsxs(Panel, { margin: "0", children: [_jsxs(Flex, { justifyContent: "space-between", children: [_jsx(ChartStats, { openValue, openDossiers }), _jsx(ChartLegend, {})] }), _jsx(DashboardChart, { statistics: statistics, range: range, setRange: setRange })] })] }));
};
export default Dashboard;
